export default __webpack_public_path__ + "static/media/JobSix9.284f9b88.jpg";